import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import { GET_PRODUCTS_STATIC_DATA } from '@/graphql/queries';
import useIsRefreshCache from 'hooks/useIsRefreshCache';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';
const useStaticProductsData = (t0, t1) => {
  const $ = _c(21);
  const {
    productIds
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    skip: t3
  } = t2;
  const skip = t3 === undefined ? false : t3;
  const isRefreshCache = useIsRefreshCache();
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? "";
  const t4 = productIds?.length || 12;
  const t5 = userLocation?.stateShortName;
  let t6;
  if ($[2] !== t5) {
    t6 = getVisitorLocationQueryVariables(t5);
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== isRefreshCache || $[5] !== productIds || $[6] !== t4 || $[7] !== t6 || $[8] !== zipCode) {
    t7 = {
      productIds,
      refreshCache: isRefreshCache,
      limit: t4,
      zipCode,
      showSearchProductsOnly: true,
      ...t6
    };
    $[4] = isRefreshCache;
    $[5] = productIds;
    $[6] = t4;
    $[7] = t6;
    $[8] = zipCode;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== skip || $[11] !== t7) {
    t8 = {
      fetchPolicy: "cache-and-network",
      variables: t7,
      skip
    };
    $[10] = skip;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const {
    data,
    loading
  } = useQuery(GET_PRODUCTS_STATIC_DATA, t8);
  let t9;
  if ($[13] !== data?.getProductsStaticData?.products) {
    t9 = data?.getProductsStaticData?.products || [];
    $[13] = data?.getProductsStaticData?.products;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== data?.getProductsStaticData?.upholsteryOptions) {
    t10 = data?.getProductsStaticData?.upholsteryOptions || [];
    $[15] = data?.getProductsStaticData?.upholsteryOptions;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== loading || $[18] !== t10 || $[19] !== t9) {
    t11 = {
      products: t9,
      upholsteryOptions: t10,
      loading
    };
    $[17] = loading;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};
export default useStaticProductsData;